// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────
   AchievementsOrb — subtle purple
   ──────────────────────────────────────────
   Mirrors InfectionOrb's structure (orb button + portal'd panel into
   .deck-map-area) with a SUBTLE purple accent — violet-400 hints at
   low opacity, neutral most of the time. Not loud, not gamey.
   ────────────────────────────────────────── */

/* Trigger tile — matches PlayerTray's .pt-orb widget shape. Violet
   identity is retained on the icon stroke + active state + badge so
   the skill-tree slot stays distinguishable inside the 6-tile row
   without re-introducing the orb-era glow shell. */
.ach-orb {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(10, 10, 14, 0.55);
  color: rgba(196, 181, 253, 0.78);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 4px 14px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  outline: none;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;
}

.ach-orb:hover {
  background: rgba(167, 139, 250, 0.10);
  border-color: rgba(167, 139, 250, 0.40);
  color: rgba(221, 214, 254, 0.96);
}

.ach-orb:active {
  transform: scale(0.96);
}

.ach-orb:focus-visible {
  border-color: rgba(167, 139, 250, 0.65);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 0 1px rgba(167, 139, 250, 0.5),
    0 4px 14px rgba(0, 0, 0, 0.45);
}

/* Legacy ring/halo children kept in JSX for backwards compat;
   suppressed visually in widget mode. */
.ach-orb-ring {
  display: none;
}

.ach-orb::before {
  display: none;
  content: none;
}

.ach-orb--active {
  border-color: rgba(167, 139, 250, 0.55);
  background: rgba(167, 139, 250, 0.16);
  color: rgba(237, 233, 254, 1);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.06) inset,
    0 0 0 1px rgba(167, 139, 250, 0.28),
    0 4px 14px rgba(0, 0, 0, 0.45);
}

/* ──────────────────────────────────────────
   First-visit attention cue (anon landing)
   A pulsing violet GLOW (no text) so new visitors notice the skill-tree orb.
   Vanishes the moment the parent clears \`hint\` (first click). No transform/
   movement — the orb stays click-stable.
   ────────────────────────────────────────── */
.ach-orb--hint {
  border-color: rgba(167, 139, 250, 0.65);
  color: rgba(237, 233, 254, 1);
  animation: ach-orb-hint-glow 1.8s ease-in-out infinite;
}

.ach-orb-hint-pulse {
  position: absolute;
  inset: -4px;
  border-radius: 12px;
  border: 2px solid rgba(167, 139, 250, 0.85);
  pointer-events: none;
  animation: ach-orb-hint-ring 1.6s ease-out infinite;
}

@keyframes ach-orb-hint-ring {
  0% { opacity: 0.9; transform: scale(1); }
  100% { opacity: 0; transform: scale(1.6); }
}

@keyframes ach-orb-hint-glow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(167, 139, 250, 0), 0 4px 14px rgba(0, 0, 0, 0.45); }
  50% { box-shadow: 0 0 18px 4px rgba(167, 139, 250, 0.6), 0 4px 14px rgba(0, 0, 0, 0.45); }
}

/* Count badge — small pill at top-right */
.ach-orb-badge {
  position: absolute;
  top: -3px;
  right: -3px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: rgba(167, 139, 250, 0.92);
  color: #1c1330;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid rgba(14, 12, 22, 0.95);
  box-shadow: 0 0 8px rgba(167, 139, 250, 0.32);
  pointer-events: none;
}

@keyframes ach-orb-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes ach-orb-pulse {
  0%, 100% { opacity: 0.30; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(1.05); }
}

/* ──────────────────────────────────────────
   Skill-tree variant overrides on GameViewportModal
   Overlay / body / close button geometry lives on the primitive
   (see GameViewportModal.css). These rules just paint the panel purple
   for the skill-tree view.
   ────────────────────────────────────────── */
.gvm-overlay--skill-tree {
  padding: 40px;
  background:
    radial-gradient(circle at 50% 50%, rgba(167, 139, 250, 0.08) 0%, rgba(8, 6, 14, 0.42) 70%);
}

.gvm-body--skill-tree {
  background:
    linear-gradient(135deg, rgba(28, 22, 44, 0.30) 0%, rgba(18, 14, 30, 0.24) 100%);
  border-color: rgba(167, 139, 250, 0.22);
  box-shadow:
    0 0 0 1px rgba(167, 139, 250, 0.06),
    0 20px 50px rgba(0, 0, 0, 0.55),
    0 0 36px rgba(167, 139, 250, 0.06) inset;
}

.gvm-overlay--skill-tree .gvm-close {
  border-color: rgba(167, 139, 250, 0.22);
  background: rgba(20, 14, 36, 0.85);
  color: rgba(221, 214, 254, 0.78);
}

.gvm-overlay--skill-tree .gvm-close:hover {
  background: rgba(28, 20, 48, 0.95);
  color: rgba(237, 233, 254, 1);
  border-color: rgba(167, 139, 250, 0.55);
}

.gvm-content--skill-tree {
  padding: 16px 18px 20px;
}

/* Header */
.ach-orb-header {
  position: relative;
  z-index: 6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 56px 12px 18px;
  border-bottom: 1px solid rgba(167, 139, 250, 0.12);
  flex-shrink: 0;
}

.ach-orb-header-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.ach-orb-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a78bfa;
  box-shadow: 0 0 6px rgba(167, 139, 250, 0.55);
  animation: ach-orb-pulse-dot 3s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes ach-orb-pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
}

.ach-orb-eyebrow {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(196, 181, 253, 0.78);
}

.ach-orb-divider {
  font-size: 10px;
  color: rgba(196, 181, 253, 0.22);
  font-weight: 300;
}

.ach-orb-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(243, 244, 246, 0.92);
  letter-spacing: 0.2px;
}

/* Scrollbar tinting for the skill-tree variant content area. The primitive
   provides default scrollbar geometry; this overrides the thumb tint to
   match the violet palette. */
.gvm-content--skill-tree::-webkit-scrollbar-thumb {
  background: rgba(196, 181, 253, 0.10);
}
.gvm-content--skill-tree::-webkit-scrollbar-thumb:hover {
  background: rgba(167, 139, 250, 0.36);
}

.ach-orb-section {
  margin-bottom: 18px;
}
.ach-orb-section:last-child {
  margin-bottom: 0;
}

.ach-orb-section-title {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(196, 181, 253, 0.62);
  margin: 0 0 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(167, 139, 250, 0.10);
}

.ach-orb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 8px;
}

.ach-orb-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: rgba(167, 139, 250, 0.04);
  border: 1px solid rgba(167, 139, 250, 0.16);
  border-radius: 4px;
  transition: background 0.18s ease, border-color 0.18s ease;
  min-width: 0;
}

.ach-orb-chip:hover {
  background: rgba(167, 139, 250, 0.10);
  border-color: rgba(167, 139, 250, 0.32);
}

.ach-orb-chip--earned {
  background: rgba(167, 139, 250, 0.08);
  border-color: rgba(167, 139, 250, 0.22);
}

.ach-orb-chip--locked {
  opacity: 0.46;
}

.ach-orb-chip-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(167, 139, 250, 0.10);
  border: 1px solid rgba(167, 139, 250, 0.18);
  color: rgba(196, 181, 253, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ach-orb-chip--earned .ach-orb-chip-icon {
  background: rgba(167, 139, 250, 0.16);
  border-color: rgba(167, 139, 250, 0.42);
  color: rgba(237, 233, 254, 1);
  box-shadow: 0 0 10px rgba(167, 139, 250, 0.18);
}

.ach-orb-chip-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1;
}

.ach-orb-chip-name {
  font-size: 12px;
  font-weight: 600;
  color: rgba(243, 244, 246, 0.94);
  letter-spacing: 0.1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ach-orb-chip-bar {
  height: 3px;
  border-radius: 2px;
  background: rgba(167, 139, 250, 0.10);
  overflow: hidden;
}

.ach-orb-chip-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, rgba(167, 139, 250, 0.78), rgba(196, 181, 253, 0.92));
  border-radius: 2px;
  transition: width 400ms ease-out;
}

.ach-orb-chip-meta {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  color: rgba(196, 181, 253, 0.62);
  font-variant-numeric: tabular-nums;
}

.ach-orb-empty {
  padding: 40px 20px;
  text-align: center;
  font-size: 13px;
  color: rgba(196, 181, 253, 0.55);
  letter-spacing: 0.4px;
}

@media (prefers-reduced-motion: reduce) {
  .ach-orb-ring,
  .ach-orb::before,
  .ach-orb-status-dot,
  .ach-orb--hint,
  .ach-orb-hint-pulse {
    animation: none;
  }
}

/* ──────────────────────────────────────────
   Skill-Tree WIP view (renders inside ach-orb-body)
   Bottom-up: tiers stack with Genesis at the bottom. Diagnostic-first —
   information density beats prettiness while we iterate.
   ────────────────────────────────────────── */

.stree-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.stree-summary {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 6px;
  padding: 10px 12px;
  background: rgba(167, 139, 250, 0.04);
  border: 1px solid rgba(167, 139, 250, 0.12);
  border-radius: 4px;
}

.stree-summary-stat {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.stree-summary-label {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(196, 181, 253, 0.55);
}

.stree-summary-value {
  font-size: 16px;
  font-weight: 700;
  color: rgba(243, 244, 246, 0.95);
  font-variant-numeric: tabular-nums;
}

.stree-summary-stat--warn .stree-summary-value {
  color: #f97316;
}

.stree-tier {
  border-top: 1px dashed rgba(167, 139, 250, 0.10);
  padding-top: 10px;
}

.stree-tier:first-of-type {
  border-top: none;
  padding-top: 0;
}

.stree-tier-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(196, 181, 253, 0.78);
  margin: 0 0 8px;
}

.stree-tier-count {
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(167, 139, 250, 0.10);
  border: 1px solid rgba(167, 139, 250, 0.22);
  color: rgba(221, 214, 254, 0.86);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
}

.stree-tier-empty {
  padding: 14px 12px;
  font-size: 11px;
  color: rgba(196, 181, 253, 0.5);
  font-style: italic;
  background: rgba(167, 139, 250, 0.02);
  border: 1px dashed rgba(167, 139, 250, 0.10);
  border-radius: 4px;
  line-height: 1.5;
}

.stree-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 6px;
}

/* Node tile — colored by gate state */
.stree-node {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  background: rgba(167, 139, 250, 0.03);
  border: 1px solid rgba(167, 139, 250, 0.14);
  border-radius: 4px;
  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
  min-width: 0;
  position: relative;
  cursor: help;
}

.stree-node:hover {
  background: rgba(167, 139, 250, 0.08);
  border-color: rgba(167, 139, 250, 0.32);
  transform: translateY(-1px);
}

.stree-node.is-owned {
  background: rgba(167, 139, 250, 0.10);
  border-color: rgba(167, 139, 250, 0.42);
  box-shadow: 0 0 12px rgba(167, 139, 250, 0.12);
}

.stree-node--genesis {
  background: rgba(245, 158, 11, 0.06);
  border-color: rgba(245, 158, 11, 0.32);
}

.stree-node--genesis.is-owned {
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.55);
  box-shadow: 0 0 14px rgba(245, 158, 11, 0.18);
}

.stree-node--starter {
  border-color: rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.04);
}

.stree-node--criterion {
  border-color: rgba(34, 197, 94, 0.32);
  background: rgba(34, 197, 94, 0.04);
}

.stree-node--legacy-earned {
  border-color: rgba(167, 139, 250, 0.32);
  background: rgba(167, 139, 250, 0.06);
}

.stree-node--legacy-locked {
  opacity: 0.7;
  border-style: dashed;
}

.stree-node--broken {
  border-color: rgba(239, 68, 68, 0.42);
  background: rgba(239, 68, 68, 0.06);
}

.stree-node--open {
  border-color: rgba(148, 163, 184, 0.22);
  background: rgba(148, 163, 184, 0.03);
  opacity: 0.86;
}

.stree-node-head {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.stree-node-name {
  font-size: 12px;
  font-weight: 600;
  color: rgba(243, 244, 246, 0.94);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.stree-badge {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.10em;
  padding: 2px 5px;
  border-radius: 2px;
  flex-shrink: 0;
  text-transform: uppercase;
}

.stree-badge--owned {
  background: rgba(34, 197, 94, 0.20);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.42);
}

.stree-badge--chosen {
  background: rgba(245, 158, 11, 0.20);
  color: #fcd34d;
  border: 1px solid rgba(245, 158, 11, 0.55);
}

.stree-badge--unlocked {
  background: rgba(167, 139, 250, 0.18);
  color: rgba(221, 214, 254, 1);
  border: 1px solid rgba(167, 139, 250, 0.42);
}

.stree-node-gate {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 9px;
  letter-spacing: 0.10em;
  color: rgba(196, 181, 253, 0.65);
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stree-node--broken .stree-node-gate {
  color: #fca5a5;
}

.stree-node--criterion .stree-node-gate {
  color: #86efac;
}

.stree-node--starter .stree-node-gate {
  color: #7dd3fc;
}

.stree-node--genesis .stree-node-gate {
  color: #fcd34d;
}

.stree-criterion {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 2px;
}

.stree-criterion-meta {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 9px;
  letter-spacing: 0.04em;
  color: rgba(196, 181, 253, 0.62);
  font-variant-numeric: tabular-nums;
  min-width: 0;
}

.stree-criterion-meta span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.stree-criterion-bar {
  height: 3px;
  border-radius: 2px;
  background: rgba(34, 197, 94, 0.12);
  overflow: hidden;
}

.stree-criterion-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, rgba(34, 197, 94, 0.85), rgba(134, 239, 172, 0.95));
  border-radius: 2px;
  transition: width 400ms ease-out;
}

.stree-node-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  margin-top: auto;
  padding-top: 4px;
  border-top: 1px solid rgba(167, 139, 250, 0.06);
}

.stree-cost {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 10px;
  font-weight: 600;
  color: rgba(196, 181, 253, 0.78);
  letter-spacing: 0.04em;
}

.stree-effect {
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 9px;
  color: rgba(196, 181, 253, 0.55);
  letter-spacing: 0.04em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 60%;
}

/* Narrower viewports — collapse summary grid */
@media (max-width: 900px) {
  .stree-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AchievementsOrb/AchievementsOrb.css"],"names":[],"mappings":"AAAA;;;;;;+CAM+C;;AAE/C;;;mDAGmD;AACnD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC;;kCAEgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,eAAe;EACf;;;;wBAIsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC;;;kCAGgC;AAClC;;AAEA;wCACwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,6BAA6B;EAC7B;;;kCAGgC;AAClC;;AAEA;;;;;+CAK+C;AAC/C;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,KAAK,YAAY,EAAE,mBAAmB,EAAE;EACxC,OAAO,UAAU,EAAE,qBAAqB,EAAE;AAC5C;;AAEA;EACE,WAAW,0EAA0E,EAAE;EACvF,MAAM,iFAAiF,EAAE;AAC3F;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,aAAa,EAAE,mBAAmB,EAAE;EAC/C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;;;;;+CAK+C;AAC/C;EACE,aAAa;EACb;8FAC4F;AAC9F;;AAEA;EACE;mFACiF;EACjF,uCAAuC;EACvC;;;4CAG0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;8BAE8B;AAC9B;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wFAAwF;EACxF,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE;;;;;IAKE,eAAe;EACjB;AACF;;AAEA;;;;+CAI+C;;AAE/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gEAAgE;EAChE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gFAAgF;EAChF,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gEAAgE;EAChE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,gEAAgE;EAChE,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gEAAgE;EAChE,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sFAAsF;EACtF,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":["/* ──────────────────────────────────────────\n   AchievementsOrb — subtle purple\n   ──────────────────────────────────────────\n   Mirrors InfectionOrb's structure (orb button + portal'd panel into\n   .deck-map-area) with a SUBTLE purple accent — violet-400 hints at\n   low opacity, neutral most of the time. Not loud, not gamey.\n   ────────────────────────────────────────── */\n\n/* Trigger tile — matches PlayerTray's .pt-orb widget shape. Violet\n   identity is retained on the icon stroke + active state + badge so\n   the skill-tree slot stays distinguishable inside the 6-tile row\n   without re-introducing the orb-era glow shell. */\n.ach-orb {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  background: rgba(10, 10, 14, 0.55);\n  color: rgba(196, 181, 253, 0.78);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 4px 14px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.ach-orb:hover {\n  background: rgba(167, 139, 250, 0.10);\n  border-color: rgba(167, 139, 250, 0.40);\n  color: rgba(221, 214, 254, 0.96);\n}\n\n.ach-orb:active {\n  transform: scale(0.96);\n}\n\n.ach-orb:focus-visible {\n  border-color: rgba(167, 139, 250, 0.65);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 0 1px rgba(167, 139, 250, 0.5),\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n/* Legacy ring/halo children kept in JSX for backwards compat;\n   suppressed visually in widget mode. */\n.ach-orb-ring {\n  display: none;\n}\n\n.ach-orb::before {\n  display: none;\n  content: none;\n}\n\n.ach-orb--active {\n  border-color: rgba(167, 139, 250, 0.55);\n  background: rgba(167, 139, 250, 0.16);\n  color: rgba(237, 233, 254, 1);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.06) inset,\n    0 0 0 1px rgba(167, 139, 250, 0.28),\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n/* ──────────────────────────────────────────\n   First-visit attention cue (anon landing)\n   A pulsing violet GLOW (no text) so new visitors notice the skill-tree orb.\n   Vanishes the moment the parent clears `hint` (first click). No transform/\n   movement — the orb stays click-stable.\n   ────────────────────────────────────────── */\n.ach-orb--hint {\n  border-color: rgba(167, 139, 250, 0.65);\n  color: rgba(237, 233, 254, 1);\n  animation: ach-orb-hint-glow 1.8s ease-in-out infinite;\n}\n\n.ach-orb-hint-pulse {\n  position: absolute;\n  inset: -4px;\n  border-radius: 12px;\n  border: 2px solid rgba(167, 139, 250, 0.85);\n  pointer-events: none;\n  animation: ach-orb-hint-ring 1.6s ease-out infinite;\n}\n\n@keyframes ach-orb-hint-ring {\n  0% { opacity: 0.9; transform: scale(1); }\n  100% { opacity: 0; transform: scale(1.6); }\n}\n\n@keyframes ach-orb-hint-glow {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(167, 139, 250, 0), 0 4px 14px rgba(0, 0, 0, 0.45); }\n  50% { box-shadow: 0 0 18px 4px rgba(167, 139, 250, 0.6), 0 4px 14px rgba(0, 0, 0, 0.45); }\n}\n\n/* Count badge — small pill at top-right */\n.ach-orb-badge {\n  position: absolute;\n  top: -3px;\n  right: -3px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: rgba(167, 139, 250, 0.92);\n  color: #1c1330;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid rgba(14, 12, 22, 0.95);\n  box-shadow: 0 0 8px rgba(167, 139, 250, 0.32);\n  pointer-events: none;\n}\n\n@keyframes ach-orb-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes ach-orb-pulse {\n  0%, 100% { opacity: 0.30; transform: scale(1); }\n  50% { opacity: 0.55; transform: scale(1.05); }\n}\n\n/* ──────────────────────────────────────────\n   Skill-tree variant overrides on GameViewportModal\n   Overlay / body / close button geometry lives on the primitive\n   (see GameViewportModal.css). These rules just paint the panel purple\n   for the skill-tree view.\n   ────────────────────────────────────────── */\n.gvm-overlay--skill-tree {\n  padding: 40px;\n  background:\n    radial-gradient(circle at 50% 50%, rgba(167, 139, 250, 0.08) 0%, rgba(8, 6, 14, 0.42) 70%);\n}\n\n.gvm-body--skill-tree {\n  background:\n    linear-gradient(135deg, rgba(28, 22, 44, 0.30) 0%, rgba(18, 14, 30, 0.24) 100%);\n  border-color: rgba(167, 139, 250, 0.22);\n  box-shadow:\n    0 0 0 1px rgba(167, 139, 250, 0.06),\n    0 20px 50px rgba(0, 0, 0, 0.55),\n    0 0 36px rgba(167, 139, 250, 0.06) inset;\n}\n\n.gvm-overlay--skill-tree .gvm-close {\n  border-color: rgba(167, 139, 250, 0.22);\n  background: rgba(20, 14, 36, 0.85);\n  color: rgba(221, 214, 254, 0.78);\n}\n\n.gvm-overlay--skill-tree .gvm-close:hover {\n  background: rgba(28, 20, 48, 0.95);\n  color: rgba(237, 233, 254, 1);\n  border-color: rgba(167, 139, 250, 0.55);\n}\n\n.gvm-content--skill-tree {\n  padding: 16px 18px 20px;\n}\n\n/* Header */\n.ach-orb-header {\n  position: relative;\n  z-index: 6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 56px 12px 18px;\n  border-bottom: 1px solid rgba(167, 139, 250, 0.12);\n  flex-shrink: 0;\n}\n\n.ach-orb-header-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.ach-orb-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #a78bfa;\n  box-shadow: 0 0 6px rgba(167, 139, 250, 0.55);\n  animation: ach-orb-pulse-dot 3s ease-in-out infinite;\n  flex-shrink: 0;\n}\n\n@keyframes ach-orb-pulse-dot {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.55; }\n}\n\n.ach-orb-eyebrow {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(196, 181, 253, 0.78);\n}\n\n.ach-orb-divider {\n  font-size: 10px;\n  color: rgba(196, 181, 253, 0.22);\n  font-weight: 300;\n}\n\n.ach-orb-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(243, 244, 246, 0.92);\n  letter-spacing: 0.2px;\n}\n\n/* Scrollbar tinting for the skill-tree variant content area. The primitive\n   provides default scrollbar geometry; this overrides the thumb tint to\n   match the violet palette. */\n.gvm-content--skill-tree::-webkit-scrollbar-thumb {\n  background: rgba(196, 181, 253, 0.10);\n}\n.gvm-content--skill-tree::-webkit-scrollbar-thumb:hover {\n  background: rgba(167, 139, 250, 0.36);\n}\n\n.ach-orb-section {\n  margin-bottom: 18px;\n}\n.ach-orb-section:last-child {\n  margin-bottom: 0;\n}\n\n.ach-orb-section-title {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(196, 181, 253, 0.62);\n  margin: 0 0 10px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(167, 139, 250, 0.10);\n}\n\n.ach-orb-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 8px;\n}\n\n.ach-orb-chip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: rgba(167, 139, 250, 0.04);\n  border: 1px solid rgba(167, 139, 250, 0.16);\n  border-radius: 4px;\n  transition: background 0.18s ease, border-color 0.18s ease;\n  min-width: 0;\n}\n\n.ach-orb-chip:hover {\n  background: rgba(167, 139, 250, 0.10);\n  border-color: rgba(167, 139, 250, 0.32);\n}\n\n.ach-orb-chip--earned {\n  background: rgba(167, 139, 250, 0.08);\n  border-color: rgba(167, 139, 250, 0.22);\n}\n\n.ach-orb-chip--locked {\n  opacity: 0.46;\n}\n\n.ach-orb-chip-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  background: rgba(167, 139, 250, 0.10);\n  border: 1px solid rgba(167, 139, 250, 0.18);\n  color: rgba(196, 181, 253, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ach-orb-chip--earned .ach-orb-chip-icon {\n  background: rgba(167, 139, 250, 0.16);\n  border-color: rgba(167, 139, 250, 0.42);\n  color: rgba(237, 233, 254, 1);\n  box-shadow: 0 0 10px rgba(167, 139, 250, 0.18);\n}\n\n.ach-orb-chip-body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n}\n\n.ach-orb-chip-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(243, 244, 246, 0.94);\n  letter-spacing: 0.1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ach-orb-chip-bar {\n  height: 3px;\n  border-radius: 2px;\n  background: rgba(167, 139, 250, 0.10);\n  overflow: hidden;\n}\n\n.ach-orb-chip-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, rgba(167, 139, 250, 0.78), rgba(196, 181, 253, 0.92));\n  border-radius: 2px;\n  transition: width 400ms ease-out;\n}\n\n.ach-orb-chip-meta {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10px;\n  letter-spacing: 0.08em;\n  color: rgba(196, 181, 253, 0.62);\n  font-variant-numeric: tabular-nums;\n}\n\n.ach-orb-empty {\n  padding: 40px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: rgba(196, 181, 253, 0.55);\n  letter-spacing: 0.4px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ach-orb-ring,\n  .ach-orb::before,\n  .ach-orb-status-dot,\n  .ach-orb--hint,\n  .ach-orb-hint-pulse {\n    animation: none;\n  }\n}\n\n/* ──────────────────────────────────────────\n   Skill-Tree WIP view (renders inside ach-orb-body)\n   Bottom-up: tiers stack with Genesis at the bottom. Diagnostic-first —\n   information density beats prettiness while we iterate.\n   ────────────────────────────────────────── */\n\n.stree-content {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.stree-summary {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 6px;\n  padding: 10px 12px;\n  background: rgba(167, 139, 250, 0.04);\n  border: 1px solid rgba(167, 139, 250, 0.12);\n  border-radius: 4px;\n}\n\n.stree-summary-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.stree-summary-label {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: rgba(196, 181, 253, 0.55);\n}\n\n.stree-summary-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: rgba(243, 244, 246, 0.95);\n  font-variant-numeric: tabular-nums;\n}\n\n.stree-summary-stat--warn .stree-summary-value {\n  color: #f97316;\n}\n\n.stree-tier {\n  border-top: 1px dashed rgba(167, 139, 250, 0.10);\n  padding-top: 10px;\n}\n\n.stree-tier:first-of-type {\n  border-top: none;\n  padding-top: 0;\n}\n\n.stree-tier-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(196, 181, 253, 0.78);\n  margin: 0 0 8px;\n}\n\n.stree-tier-count {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: rgba(167, 139, 250, 0.10);\n  border: 1px solid rgba(167, 139, 250, 0.22);\n  color: rgba(221, 214, 254, 0.86);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.04em;\n}\n\n.stree-tier-empty {\n  padding: 14px 12px;\n  font-size: 11px;\n  color: rgba(196, 181, 253, 0.5);\n  font-style: italic;\n  background: rgba(167, 139, 250, 0.02);\n  border: 1px dashed rgba(167, 139, 250, 0.10);\n  border-radius: 4px;\n  line-height: 1.5;\n}\n\n.stree-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 6px;\n}\n\n/* Node tile — colored by gate state */\n.stree-node {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 10px;\n  background: rgba(167, 139, 250, 0.03);\n  border: 1px solid rgba(167, 139, 250, 0.14);\n  border-radius: 4px;\n  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;\n  min-width: 0;\n  position: relative;\n  cursor: help;\n}\n\n.stree-node:hover {\n  background: rgba(167, 139, 250, 0.08);\n  border-color: rgba(167, 139, 250, 0.32);\n  transform: translateY(-1px);\n}\n\n.stree-node.is-owned {\n  background: rgba(167, 139, 250, 0.10);\n  border-color: rgba(167, 139, 250, 0.42);\n  box-shadow: 0 0 12px rgba(167, 139, 250, 0.12);\n}\n\n.stree-node--genesis {\n  background: rgba(245, 158, 11, 0.06);\n  border-color: rgba(245, 158, 11, 0.32);\n}\n\n.stree-node--genesis.is-owned {\n  background: rgba(245, 158, 11, 0.14);\n  border-color: rgba(245, 158, 11, 0.55);\n  box-shadow: 0 0 14px rgba(245, 158, 11, 0.18);\n}\n\n.stree-node--starter {\n  border-color: rgba(56, 189, 248, 0.32);\n  background: rgba(56, 189, 248, 0.04);\n}\n\n.stree-node--criterion {\n  border-color: rgba(34, 197, 94, 0.32);\n  background: rgba(34, 197, 94, 0.04);\n}\n\n.stree-node--legacy-earned {\n  border-color: rgba(167, 139, 250, 0.32);\n  background: rgba(167, 139, 250, 0.06);\n}\n\n.stree-node--legacy-locked {\n  opacity: 0.7;\n  border-style: dashed;\n}\n\n.stree-node--broken {\n  border-color: rgba(239, 68, 68, 0.42);\n  background: rgba(239, 68, 68, 0.06);\n}\n\n.stree-node--open {\n  border-color: rgba(148, 163, 184, 0.22);\n  background: rgba(148, 163, 184, 0.03);\n  opacity: 0.86;\n}\n\n.stree-node-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.stree-node-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(243, 244, 246, 0.94);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.stree-badge {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.10em;\n  padding: 2px 5px;\n  border-radius: 2px;\n  flex-shrink: 0;\n  text-transform: uppercase;\n}\n\n.stree-badge--owned {\n  background: rgba(34, 197, 94, 0.20);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.42);\n}\n\n.stree-badge--chosen {\n  background: rgba(245, 158, 11, 0.20);\n  color: #fcd34d;\n  border: 1px solid rgba(245, 158, 11, 0.55);\n}\n\n.stree-badge--unlocked {\n  background: rgba(167, 139, 250, 0.18);\n  color: rgba(221, 214, 254, 1);\n  border: 1px solid rgba(167, 139, 250, 0.42);\n}\n\n.stree-node-gate {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 9px;\n  letter-spacing: 0.10em;\n  color: rgba(196, 181, 253, 0.65);\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.stree-node--broken .stree-node-gate {\n  color: #fca5a5;\n}\n\n.stree-node--criterion .stree-node-gate {\n  color: #86efac;\n}\n\n.stree-node--starter .stree-node-gate {\n  color: #7dd3fc;\n}\n\n.stree-node--genesis .stree-node-gate {\n  color: #fcd34d;\n}\n\n.stree-criterion {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-top: 2px;\n}\n\n.stree-criterion-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 6px;\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 9px;\n  letter-spacing: 0.04em;\n  color: rgba(196, 181, 253, 0.62);\n  font-variant-numeric: tabular-nums;\n  min-width: 0;\n}\n\n.stree-criterion-meta span:first-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.stree-criterion-bar {\n  height: 3px;\n  border-radius: 2px;\n  background: rgba(34, 197, 94, 0.12);\n  overflow: hidden;\n}\n\n.stree-criterion-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, rgba(34, 197, 94, 0.85), rgba(134, 239, 172, 0.95));\n  border-radius: 2px;\n  transition: width 400ms ease-out;\n}\n\n.stree-node-foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n  margin-top: auto;\n  padding-top: 4px;\n  border-top: 1px solid rgba(167, 139, 250, 0.06);\n}\n\n.stree-cost {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 600;\n  color: rgba(196, 181, 253, 0.78);\n  letter-spacing: 0.04em;\n}\n\n.stree-effect {\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 9px;\n  color: rgba(196, 181, 253, 0.55);\n  letter-spacing: 0.04em;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 60%;\n}\n\n/* Narrower viewports — collapse summary grid */\n@media (max-width: 900px) {\n  .stree-summary {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
